import Icon from "@ant-design/icons"
import { ReactComponent as FranceFlag } from "./france.svg"

const FranceFlagIcon = (props: any) => (
  <Icon component={FranceFlag} {...props} />
)

export default FranceFlagIcon
